import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Badge } from '@/components/ui/misc';
import { DEFAULT_LAUNCH_LIMITS } from '@visiward/shared';

const included = [
  `${DEFAULT_LAUNCH_LIMITS.maxProjects} saved projects`,
  `${DEFAULT_LAUNCH_LIMITS.maxRegisteredRunsPerDay} analyses per day`,
  `${DEFAULT_LAUNCH_LIMITS.maxPromptsPerRun} prompts per analysis`,
  `${DEFAULT_LAUNCH_LIMITS.maxCompetitorsPerProject} competitors per project`,
  `${DEFAULT_LAUNCH_LIMITS.savedHistoryDays} days of saved history`,
  'Full results dashboard & recommendations',
];

export function Pricing() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-16 sm:px-6">
      <div className="mx-auto max-w-2xl text-center">
        <Badge tone="teal" className="mb-4">
          Launch pricing
        </Badge>
        <h1 className="text-4xl font-bold tracking-tight text-text-primary">
          Free during the launch period
        </h1>
        <p className="mt-4 text-lg text-text-secondary">
          Visiward is temporarily free while we launch. Create an account to save your work and track
          visibility over time.
        </p>
      </div>

      <div className="mx-auto mt-12 max-w-md">
        <div className="panel-raised relative overflow-hidden p-8 shadow-glow">
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-accent-blue/8 to-transparent" />
          <div className="relative">
            <p className="text-sm font-medium text-accent-blue">Launch-free plan</p>
            <div className="mt-2 flex items-baseline gap-2">
              <span className="text-5xl font-bold text-text-primary">$0</span>
              <span className="text-text-muted">/ month</span>
            </div>
            <p className="mt-2 text-sm text-text-secondary">
              No credit card required during the launch period.
            </p>
            <ul className="mt-6 space-y-3">
              {included.map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-sm text-text-primary">
                  <Check size={16} className="mt-0.5 shrink-0 text-accent-teal" />
                  {item}
                </li>
              ))}
            </ul>
            <Link to="/register" className="mt-8 block">
              <Button className="w-full" size="lg">
                Get started free <ArrowRight size={18} />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-2xl">
        <div className="panel p-6 text-center">
          <h3 className="text-lg font-semibold text-text-primary">Advanced Analysis</h3>
          <p className="mt-2 text-sm text-text-secondary">
            Available for selected businesses and agencies. Contact us for access.
          </p>
          <Link to="/contact" className="mt-4 inline-block">
            <Button variant="secondary">Contact us</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
